export var DelegationType;
(function (DelegationType) {
    DelegationType["INCOMING"] = "popup_html_incoming";
    DelegationType["OUTGOING"] = "popup_html_outgoing";
    DelegationType["PENDING_OUTGOING_UNDELEGATION"] = "popup_html_pending_undelegation";
})(DelegationType || (DelegationType = {}));
